import FlatButton from './FlatButton';

export default FlatButton;



// WEBPACK FOOTER //
// ./src/client/Components/FlatButton/index.js